import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { type Blocker } from 'react-router'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type KnowledgeBaseCreateDocumentStore } from './knowledgeBaseCreateDocumentStore'

export class DocumentBlockerStore {
  private _modalId = nanoid()

  constructor(private _createDocumentStore: KnowledgeBaseCreateDocumentStore) {
    makeAutoObservable(this)
  }

  get isExistChanges() {
    return this._createDocumentStore.isExistChanges
  }

  handleShowBlockerModal = (blocker: Blocker) => {
    if (blocker.state !== 'blocked') return

    const onNext = () => {
      const path = blocker.location.pathname
      blocker.proceed()

      uiStore.setRoutesBlocker(null)
      uiStore.changeRoute({
        path,
        type: 'vue',
        method: 'replace',
      })
      modalStore.closeModal(this._modalId)
    }
    const id = this._createDocumentStore.id
    const isSavedDraftState = this._createDocumentStore.isSavedDraftState
    const isDraftOrNewDocument = !id || isSavedDraftState

    modalStore.addModal({
      id: this._modalId,
      type: ModalTypeList.WARNING,
      title: 'Save your document before closing?',
      primaryAction: {
        text: isDraftOrNewDocument ? 'Save as draft' : 'Save changes',
        onAction: async () => {
          try {
            const saveSuccess = await this._createDocumentStore.onHandleSave(!!isDraftOrNewDocument)
            if (saveSuccess) {
              onNext()
            } else {
              modalStore.closeModal(this._modalId)
            }
          } catch (e) {
            logger.error(e)
            modalStore.closeModal(this._modalId)
          }
        },
      },
      additionalSecondaryAction: {
        text: 'Don’t save',
        onAction: onNext,
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(this._modalId)
        },
      },
    })
  }
}
